import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import GridContainer from "../../../../../components/Grid/GridContainer.js";
import GridItem from "../../../../../components/Grid/GridItem.js";
import { FaWeightHanging } from 'react-icons/fa';
import {
    container,
    main,
    mainRaised,
    mrAuto,
    mlAuto,
} from "../../../../../assets/jss/material-kit-pro-react.js";

import Lorry from "../../../../../assets/img/lorryicon.png";
import FlatbedTruck from "../../../../../assets/img/flatbed-truck-cropped.svg";
import { formatNumberWithDecimals } from '../../../../utils/formatNumber.js';

const useStyles = theme => ({
    main,
    mainRaised,
    mrAuto,
    mlAuto,
    container: {
        ...container,
        zIndex: 2,
    },
    iconHolder: {
        padding: "25px 0px 30px 0px",
        textAlign: "center"
    },

    lorryContainer: {
        position: 'relative',
        display: 'inline-block',
      },
    weightIcons: {
        height: '70px ',
        width: '170px'
    },
    progressWrapper: {
        position: 'absolute',
        left: '22%',   /* adjust so it lines up with lorry bed start */
        top: '38%',    /* adjust so it sits inside the bed */
        height: '25%', /* thickness of the bed */
        width: '65%',  /* length of the lorry bed */
        background: 'rgba(200, 200, 200, 0.2)', /* faint background */
        border: '2px solid #000', /* optional border to match bed edges */
        boxSizing: 'border-box',
      },
      
      progressBar: {
        height: '100%',
        background: 'green',
        transition: 'width 0.3s',
      },
      
      progressText: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        fontWeight: 'bold',
        color: 'white',
      },
      badge: {
            display: 'inline-block',
            padding: '0.35em 0.65em',
            fontSize: '1em',
            fontWeight: '400',
            lineHeight: '1',
            color: '#fff',
            textAlign: 'center',
            whiteSpace: 'nowrap',
            verticalAlign: 'baseline',
            borderRadius: '50rem',
            backgroundColor: '#19739b'
      }

});


class OrderWeightIcons extends Component {

    render() {

        const { classes } = this.props;
        const lorryLoadPercentage = (this.props.lorryLoad * 100).toFixed(2);
        // Maximum is 442 pixels for the truck filler
        const truckFillerWidth = (442 / 100 * lorryLoadPercentage) > 442 ? 442 : (442 / 100 * lorryLoadPercentage);

        return (
            <GridContainer className={classes.iconHolder}>
                {/* <GridItem xs={12} sm={6} md={6}>
                <div className={classes.lorryContainer}>
                    <img className={classes.weightIcons} src={Lorry} alt="lorryImg" />
                    
                    <div className={classes.progressWrapper}>
                        <div className={classes.progressBar} style={{width: '70%'}}></div>
                        <div className={classes.progressText}>70%</div>formatNumberWithDecimals
                    </div>
                </div>

                    <br />
                    <h3 ><b>{this.props.lorryLoad} x</b><br /> Lorry Loads</h3>
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                    <FaWeightHanging className={classes.weightIcons} />
                    <br />
                    <h3><b>{this.props.totalWeight} </b> <br /> Total Weight (Tonnes)</h3>
                </GridItem> */}

                <GridItem xs={24} sm={12} md={12}>
                <svg class="truck" height="100%" width="100%" viewBox="0 0 1024 200" preserveAspectRatio="xMidYMid meet">
                                    <image id="flatbedtruck" href={FlatbedTruck} height="100%" width="100%" />

                                    <rect id="truckFiller" x="342" y="30" width={truckFillerWidth} height="72" fill="#25c08a" opacity="1">
                                    </rect>
                                    <text x="50%" y="37%" id="loadPercentageText" text-anchor="middle" font-weight="bold" fill="black">{formatNumberWithDecimals(this.props.totalWeight, 2)} Tonnes</text>
                                </svg>
                </GridItem>
                <GridItem xs={24} sm={12} md={12}>
                                <div style={{display: 'flex', flexDirection: 'row', gap:'50px', justifyContent: 'center'}}>
                                <span className={classes.badge}><b>{formatNumberWithDecimals(lorryLoadPercentage, 2)}%</b> of Lorry Loads</span>
                                <span className={classes.badge}><b>{formatNumberWithDecimals(this.props.totalWeight, 2)}</b> Total Weight (Tonnes)</span>
                                </div>
                </GridItem>

            </GridContainer>
            );
    }
}


const mapStateToProps = state => {
    return {
        lorryLoad: state.orderReducer.lorryLoad,
        totalWeight: state.orderReducer.totalWeight
    };
};

export default connect(mapStateToProps)(withStyles(useStyles)(OrderWeightIcons)); 